import React from 'react'

const IconMinus = ({
  width = 37,
  height = 37,
  color = 'currentColor',
  responsive = true,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39 39"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={color} 
      stroke-width="1"
      width={width}
      height={height}
      {...svgAttributes}
    >
      <g>
        <path d="M18.5,1.25c9.51,0,17.25,7.74,17.25,17.25S28.01,35.75,18.5,35.75S1.25,28.01,1.25,18.5S8.99,1.25,18.5,1.25 M18.5,0.25
          C8.42,0.25,0.25,8.42,0.25,18.5S8.42,36.75,18.5,36.75s18.25-8.17,18.25-18.25S28.58,0.25,18.5,0.25L18.5,0.25z"/>
      </g>
      <g>
        <g transform="translate(-1356, -1941)">
          <g transform="translate(1346, 1925)">
            <polygon fill={color} points="36.04,34.44 36.04,35.44 20.54,35.44 20.54,34.44 			"/>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default IconMinus
